"use client"

import { SourceOptionDropdowns } from "@/components/source-option-dropdowns"
import { VRPORNBASE_STUDIOS } from "@/lib/vrpornbase-studios"
import { useTranslations } from "next-intl"

interface VrpornbaseFilterTabsProps {
  studio: string
  onStudioChange: (value: string) => void
}

// VR Porn Base's studios (its "categories": Virtual Taboo, WankzVR, Badoink VR...), the 100 biggest; see lib/booru-sources/booru-api/vrpornbase.ts.
export function VrpornbaseFilterTabs({ studio, onStudioChange }: VrpornbaseFilterTabsProps) {
  const t = useTranslations("vrpornbaseFilterTabs")
  return (
    <SourceOptionDropdowns
      groups={[{ id: "studio", label: t("studio"), value: studio, defaultValue: "all", options: [{ value: "all", label: t("allStudios") }, ...VRPORNBASE_STUDIOS.map((s) => ({ value: s.slug, label: s.label }))] }]}
      onChange={(_, value) => onStudioChange(value)}
    />
  )
}
